export default {
  title: 'Pyydä lasku',
  form: {
    is_receipt_required: {
      label: 'Pyydä lasku sähköpostitse',
    },
    company_name: {
      placeholder: 'Yrityksen nimi (valinnainen)',
    },
    first_name: {
      placeholder: 'Etunimi',
    },
    last_name: {
      placeholder: 'Sukunimi',
    },
    address: {
      placeholder: 'Katu + numero',
    },
    zip_code: {
      placeholder: 'Postinumero',
    },
    city: {
      placeholder: 'Kaupunki',
    },
    tax_id: {
      placeholder: 'Y-tunnus',
    },
    email: {
      placeholder: 'Sähköpostiosoite',
    },
  },
};
